<template>
  <div class="wg-row">
    <div v-if="!loading" id="invoice-box" class="invoice-box">
      <table cellpadding="0" cellspacing="0">
        <tr class="top">
          <td colspan="12">
            <table>
              <tr>
                <td class="title">
                  <div style="width:100px;height:100px;">
                    <world-object-icon :type="'work'" :obj="work" :isImg="true"></world-object-icon>
                  </div>
                </td>

                <td>
                  {{ $anm22.strLang(lang, 'Invoice #: ', 'Fattura #: ') + invoice.invoiceId }}
                  <br />
                  {{ $anm22.strLang(lang, 'Date: ', 'Data: ') + $moment.unix(invoice.invoiceDate).format('DD/MM/YYYY') }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="information">
          <td colspan="12">
            <table>
              <tr>
                <td>
                  {{ work.name }}
                  <br />
                  {{ place.addressStreet + ' ' + place.addressNumber }}
                  <br />
                  {{ place.addressZip + ' ' + place.addressCity + ', ' + place.addressState + ', ' + $anm22.tableClasses.worldCountry().getById(place.addressCountry)[lang] }}
                  <br />
                  C.F: {{ work.taxCode }}
                  <br />
                  P.IVA: {{ work.vatCode }}
                </td>

                <td>
                  <template v-if="customerData">
                    {{ customerData.name }}
                    <br />
                    {{ customerData.street + ' ' + customerData.number }}
                    <br />
                    {{ customerData.zip + ' ' + customerData.city + ', ' + customerData.state + ', ' + $anm22.tableClasses.worldCountry().getById(customerData.country)[lang] }}
                    <br />
                    C.F: {{ customerData.taxCode }}
                    <br />
                    P.IVA: {{ customerData.vatCode }}
                  </template>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="heading">
          <td colspan="12">{{ $anm22.strLang(lang, 'Payment', 'Pagamento') }}</td>
        </tr>

        <tr class="details">
          <td colspan="12">
            <template
              v-if="invoice.paymentDate"
            >{{ $anm22.strLang(lang, 'Payed on: ', 'Pagato il: ') + $moment.unix(invoice.paymentDate).format('DD-MM-YYYY') }}</template>
            <template
              v-else
            >{{ $anm22.strLang(lang, 'Due date: ', 'Scadenza pagamento: ') + $moment.unix(invoice.paymentExpiration).format('DD-MM-YYYY') }}</template>
          </td>
        </tr>

        <tr class="heading">
          <td colspan="9">{{ $anm22.strLang(lang, 'Description', 'Dettaglio') }}</td>
          <td>{{ $anm22.strLang(lang, 'Qty', 'Qnt') }}</td>
          <td>{{ $anm22.strLang(lang, 'Price', 'Prezzo') }}</td>
          <td>{{ $anm22.strLang(lang, 'VAT', 'IVA') }}</td>
        </tr>

        <tr v-for="(line,i) in lines" :key="'line-'+i" class="item last">
          <td colspan="9">{{ line.description }}</td>

          <td>{{ line.quantity }}</td>
          <td>{{ 'EUR ' + line.unitPrice.toFixed(2) }}</td>
          <td>{{ line.vatPercentage.toFixed(2) }}</td>
        </tr>

        <tr class="total">
          <td colspan="2"></td>

          <td colspan="10">
            {{ $anm22.strLang(lang, 'Subtotal: EUR ', 'Totale imponibile: EUR ') + invoice.noTaxTotal.toFixed(2) }}<br>
            {{ $anm22.strLang(lang, 'VAT ', 'IVA ') + ': EUR ' + invoice.vatValue.toFixed(2) }}<br>
            {{ $anm22.strLang(lang, 'Total: EUR ', 'Totale: EUR ') + invoice.total.toFixed(2) }}
          </td>
        </tr>
      </table>

      <div style="padding-top:10px;text-align:center;">
        <a href="https://www.anm22.it/app/food/" style="text-decoration:none;">
          <img
            src="https://www.anm22.it/app/world/images/apps/app-food.png"
            style="height:30px;display:inline-block;margin-right:10px;vertical-align:middle;"
          >
          <div
            style="color:#ffc400;font-size:16px;display:inline-block;vertical-align: middle;"
          >ANM22 Food</div>
        </a>
      </div>
    </div>
    <div class="vertical-height-div" style="height:30px;"></div>
    <!-- Print buttons -->
    <div class="wg-row" style="flex-wrap:nowrap;justify-content:center;">
      <div
        v-for="(printer,index) in printers"
        :key="'printer-invoice-'+index"
        class="display-flex action-btn-with-desc"
        style="margin:0 10px;"
      >
        <img
          :src="$anm22.icons.getWorldIcon('print')"
          class="btn print-button-nfis"
          :title="printer.name"
          @click="print(printer.idPrinter);"
        >
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="com-anm22-app-text-m">{{ printer.name }}</div>
      </div>
      <div
        class="display-flex action-btn-with-desc"
      >
        <img
          :src="$anm22.icons.getWorldIcon('fileDefault')"
          class="btn print-button-nfis"
          :title="'Browser'"
          @click="printBrowser"
        >
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="com-anm22-app-text-m">{{ 'Stampa con browser' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    invoice: {
      type: Object,
      required: true
    },
    customerData: {
      type: Object,
      required: true,
    },
    lines: {
      type: Array,
      default: () => []
    },
    work: {
      type: Object,
      required: true,
    },
    place: {
      type: Object,
      required: true,
    },
    printers: {
      type: Array,
      default: () => []
    },
    invoiceCode: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    invoiceToPrint() {
      const timezone = this.place.timezone || "Europe/Rome";
      
      let body = "";
      body += this.$anm22.strLang(this.lang, 'Copy - Fiscal invoice #', 'Copia - Fattura fiscale #') + this.invoice.invoiceId;
      body += "\n";
      body += "\n" + this.$anm22.strLang(this.lang, 'Date: ', 'Data: ') + this.$moment.tz(this.invoice.invoiceDate, 'X', timezone).format('L');
      body += "\n";
      body += "\n" + this.$anm22.strLang(this.lang, 'Customer:', 'Cliente:');
      body += "\n" + this.$anm22.escapeHtml(this.customerData.name);
      body += "\n" + this.$anm22.escapeHtml(this.customerData.street) + " " + this.$anm22.escapeHtml(this.customerData.number);
      body += "\n" + this.$anm22.escapeHtml(this.customerData.zip) + " " + this.$anm22.escapeHtml(this.customerData.city) + ", " + this.$anm22.escapeHtml(this.customerData.state) + ", " + this.$anm22.tableClasses.worldCountry().getById(this.customerData.country)[this.lang];
      body += "\n" + this.$anm22.strLang(this.lang, 'TAX CODE: ', 'C.F: ') + this.customerData.taxCode;
      body += "\n" + this.$anm22.strLang(this.lang, 'VAT CODE: ', 'P.IVA: ') + this.customerData.vatCode;
      body += "\n";
      if(this.invoice.paymentDate) {
        body += "\n" + this.$anm22.strLang(this.lang, 'Payment date: ', 'Pagato il: ') + this.$moment.tz(this.invoice.paymentDate, 'X', timezone).format('L');
      } else {
        body += "\n" + this.$anm22.strLang(this.lang, 'Due date: ', 'Scadenza pagamento: ') + this.$moment.tz(this.invoice.paymentExpiration, 'X', timezone).format('L');
      }
      body += "\n";
      const s_header_desc = this.$anm22.strLang(this.lang, "Description", "Dettaglio");
      const s_header_qnt = this.$anm22.strLang(this.lang, "Qty.", "Qnt.").padStart(4, " ");
      const s_header_price = this.$anm22.strLang(this.lang, "Price", "Prezzo").padStart(11, " ");
      const s_header_vat = this.$anm22.strLang(this.lang, "VAT", "IVA").padStart(6, " ");
      body += "\n"
          + s_header_desc
          + (new Array((45 - s_header_desc.length - s_header_qnt.length - s_header_price.length - s_header_vat.length)+1).join(' '))
          + s_header_qnt
          + s_header_price
          + s_header_vat;
      body += "\n";
      this.lines.forEach(l => {
        const s_description = l.description;
        const s_qnt = ('x' + l.quantity).padStart(4, ' ');
        const s_price = ' EUR ' + l.unitPrice.toFixed(2).padStart(6, ' ');
        const s_vat = l.unitPrice.toFixed(2).padStart(6, ' ') + '%';

        if(s_description.length > 23) {
          s_description = s_description.substring(0, 23);
        }

        const spaces = 45 - s_description.length - s_qnt.length - s_price.length - s_vat.length;
        body += "\n"
            + this.$anm22.escapeHtml(s_description)
            + (new Array(spaces+1).join(' '))
            + s_qnt
            + s_price
            + s_vat;
      });
      body += "\n";
      const s_subtotal_desc = this.$anm22.strLang(this.lang, 'Subtotal', 'Totale imponibile');
      const s_subtotal_price = ' EUR ' + this.invoice.noTaxTotal.toFixed(2).padStart(6, ' ')
      body += "\n" 
          + s_subtotal_desc
          + (new Array((45 - s_subtotal_desc.length - s_subtotal_price.length)+1).join(' ')) 
          + s_subtotal_price;
      body += "\n";
      const s_vat_desc = this.$anm22.strLang(this.lang, 'VAT', 'IVA');
      const s_vat_price = ' EUR ' + this.invoice.vatValue.toFixed(2).padStart(6, ' ')
      body += "\n" 
          + s_vat_desc
          + (new Array((45 - s_vat_desc.length - s_vat_price.length)+1).join(' ')) 
          + s_vat_price;
      body += "\n";
      const s_total_desc = this.$anm22.strLang(this.lang, 'Total', 'Totale');
      const s_total_price = ' EUR ' + this.invoice.total.toFixed(2).padStart(6, ' ')
      body += "\n" 
          + s_total_desc
          + (new Array((45 - s_total_desc.length - s_total_price.length)+1).join(' ')) 
          + s_total_price;

      return body;
    }
  },
  methods: {
    print(printerId) {
      const content = new WorldPrintContent();
      content.printMode = 'text';
      content.text = this.invoiceToPrint;
      if(this.invoiceCode) {
        content.codeType = this.invoiceCode.type;
        context.codeText = this.invoiceCode.link 
            + '?id='+this.invoice.idWorldInvoice 
            + '&amp;h=' + this.$anm22.MD5(this.invoice.idWorldInvoice + this.work.idWorldWork);
      }
      window['world_printer_'+printerId].print(content);
    },
    printBrowser() {
      const html = document.getElementById("invoice-box").cloneNode(true);

      // Get all stylesheets HTML
      const headElements = [],
        inserted = [];
      for (const node of [
        ...document.querySelectorAll('link[href$=".css"], style')
      ]) {
        // stylesHtml += node.innerHTML;
        if (node.tagName === "STYLE") {
          const elem = document.createElement("style");
          elem.type = "text/css";
          elem.innerHTML = node.innerHTML;
          headElements.push(elem);
        } else {
          if (!inserted.find(s => s === node.href)) {
            inserted.push(node.href);
            const elem = document.createElement("link");
            elem.type = "text/css";
            elem.rel = "stylesheet";
            elem.href = node.href;
            headElements.push(elem);
          }
        }
      }
      this.$anm22.print(html, headElements);
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.invoice-box {
  max-width: 800px;
  margin: auto;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;

  table {
    width: 100%;
    line-height: inherit;
    text-align: left;
    td {
      padding: 5px;
      vertical-align: top;
    }
    tr {
      td:not(:first-child) {
        text-align: right;
      }
      &.top table {
        td {
          padding-bottom: 20px;
        }
        td.title {
          font-size: 45px;
          line-height: 45px;
          color: #333;
        }
      }
      &.information table td {
        padding-bottom: 40px;
      }
      &.heading td {
        background: #eee;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
      }
      &.details td {
        padding-bottom: 20px;
      }
      &.item {
        td {
          border-bottom: 1px solid #eee;
        }
        &.last td {
          border-bottom: none;
        }
      }
      &.total td {
        border-top: 2px solid #eee;
        font-weight: bold;
      }
    }
  }
}
.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
@media only screen and (max-width: 600px) {
  .invoice-box table tr {
    &.top table td {
      width: 100%;
      display: block;
      text-align: center;
    }
    &.information table td {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
}
@media print {
  .invoice-box {
    box-shadow: none;
    border: 0;
    padding: 5px;
  }
  .action-btn-with-desc {
    display: none;
  }
}
</style>